"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldSlider = void 0;
var react_1 = __importDefault(require("react"));
var FieldSlider_module_scss_1 = __importDefault(require("./FieldSlider.module.scss"));
var react_redux_1 = require("react-redux");
var selectors_1 = require("../../redux/selectors");
var formatPrice_1 = require("../../helpers/formatPrice");
var FieldSlider = function (props) {
    var titleText = props.titleText, unitOfMeasurement = props.unitOfMeasurement, initValue = props.initValue, steps = props.steps, endpoints = props.endpoints, ticksLeft = props.ticksLeft, setValue = props.setValue, fieldName = props.fieldName;
    var ticksContentWidth = props.ticksContentWidth, register = props.register, unitTicks = props.unitTicks;
    var _a = react_1.default.useState(steps.indexOf(initValue)), inputValue = _a[0], setInputValue = _a[1];
    var carPrice = (0, react_redux_1.useSelector)(selectors_1.modalSelector).selectCar.filter.car.carSelect.price;
    var max = steps.length - 1;
    var handleChange = function (e) {
        var index = Number(e.target.value);
        setInputValue(index);
        setValue(fieldName, index);
    };
    return (react_1.default.createElement("label", { className: FieldSlider_module_scss_1.default.field_slider },
        react_1.default.createElement("h3", { className: FieldSlider_module_scss_1.default.field_slider__title },
            react_1.default.createElement("span", null, titleText),
            react_1.default.createElement("span", null, fieldName === 'initial_contribution'
                ? carPrice
                    ? "".concat((0, formatPrice_1.formatPrice)((steps[inputValue] / 100) * carPrice)).concat(unitOfMeasurement)
                    : "0".concat(unitOfMeasurement)
                : "".concat(steps[inputValue] || 0).concat(unitOfMeasurement))),
        react_1.default.createElement("div", { className: FieldSlider_module_scss_1.default.field_slider__box },
            react_1.default.createElement("input", __assign({}, register, { className: FieldSlider_module_scss_1.default.field_slider__input, max: max, min: "0", step: "1", type: "range", value: inputValue, onChange: handleChange })),
            react_1.default.createElement("div", { className: FieldSlider_module_scss_1.default.field_slider__input_background, style: { width: "".concat((inputValue / max) * 100, "%") } })),
        react_1.default.createElement("div", { className: FieldSlider_module_scss_1.default.field_slider__ticks, style: { width: ticksContentWidth, left: ticksLeft } }, endpoints.map(function (endpoint) {
            return (react_1.default.createElement("span", { key: endpoint },
                endpoint,
                unitTicks));
        }))));
};
exports.FieldSlider = FieldSlider;
